<app-side-menu (sideNavMessage$)="listenerNav($event)" [language]="language" [compact]="false"></app-side-menu>
<app-nav-bar (navMessage$)="listenerNav($event)"></app-nav-bar>

<main class="content-page bg-gray">
    <form [formGroup]="search" class="form-row">
        <div class="form-group col">
            <div class="input-group">
                <div class="input-group-append">
                    <span class="input-group-text"><span class="mdi mdi-magnify search-icon"></span></span>
                </div>
                <input autocomplete="off" type="search" class="form-control" id="search" autofocus="true" formControlName="inquiry" [attr.placeholder]="words[this.language]['Find a report']" />
            </div>
        </div>
    </form>

    <div class="card-columns">
        @for (group of groupKeys; track group) {
            <div class="card">
                <div class="card-body">
                    <h3 class="card-title">{{group | lowercase}}</h3>
                </div>
                <ul class="list-group list-group-flush">
                    @for (report of groups[group]; track report.id) {
                        <li class="list-group-item">
                            <div [routerLink]="['/reports', report.token]">
                                <h4>{{words[language][report.name]}}</h4>
                                <p class="subtitle">
                                    {{report.description}}
                                </p>
                            </div>
                            <span class="material-icons" (click)="toggleFavorite(report.name, report.token)">{{icon(report.token)}}</span>
                        </li>
                    }
                </ul>
            </div>
        }
    </div>
</main>

<app-footer></app-footer>
